import {
  Container,
  OutsideClickHandler,
  Typography,
} from "src/components/ct-design";
import DownArrow from "icons/downChevron.svg";
import SortIcon from "icons/sortIcon.svg";
import Rupee from "icons/rupee.svg";
import TopRated from "icons/topRated.svg";
import { useContext, useEffect, useState } from "react";
import DropdownOptions from "components/dropdown/dropDownOptions";
import { ResultsContext } from "src/context/resultsContext/context";
import useFilters from "./customHooks/useFilters";
import classNames from "classnames";
import { isEmpty } from "src/utils/browserHelpers";
import { FilterList } from "./types";
import { sendBusUIAction } from "src/analytics/useAnalytics";

const SortingBar = () => {
  const [openSort, setOpenSort] = useState(false);
  const { filterList, selectedFilters } = useContext(ResultsContext);
  const { handleChange, handleApplyFilters } = useFilters();
  const [selectedFromDropdown, setSelectedFromDropdown] =
    useState<FilterList | null>(null);
  const handleSortSelection = (item: FilterList, index: number) => {
    if (!item.selected) {
      sendBusUIAction(
        {
          actionName: "srpSortApplied",
          sortApplied: item.value as string,
        },
        "b_srp_pageload"
      );
      const updatedFilterList = handleChange("sortBy", item, index, filterList);
      handleApplyFilters(updatedFilterList);
    }
    setOpenSort(false);
  };

  useEffect(() => {
    const selectedSort = selectedFilters.sortBy[0];

    if (
      selectedSort === "early_departure" ||
      selectedSort === "late_departure"
    ) {
      filterList.sortBy.filter((item) => {
        if (item.value === selectedSort) setSelectedFromDropdown(item);
      });
    } else setSelectedFromDropdown(null);
  }, [filterList.sortBy, setSelectedFromDropdown, selectedFilters.sortBy]);

  const sortButtonClass = classNames(
    "ba-solid p-4  flex flex-middle br-12 c-pointer",

    filterList.sortBy[0].selected ? "selected" : "bc-line-500"
  );
  const sortButton2Class = classNames(
    "ba-solid  p-4 ml-4  flex flex-middle br-12 c-pointer",
    filterList.sortBy[1].selected ? "selected" : "bc-line-500"
  );

  const sortOptionContainerclass = classNames(
    "a-solid flex flex-middle br-12 c-pointer",

    !isEmpty(selectedFromDropdown)
      ? "selected py-2 px-4"
      : "p-4 ba-solid bc-line-500"
  );

  return (
    <Container className="flex flex-between mt-6 mb-6">
      <Container className="flex">
        <Container
          className={sortButtonClass}
          onClick={() => handleSortSelection(filterList.sortBy[0], 0)}
        >
          <TopRated className="mr-3" />
          <Typography variant="B2">{filterList.sortBy[0].title}</Typography>
        </Container>

        <Container
          className={sortButton2Class}
          onClick={() => handleSortSelection(filterList.sortBy[1], 1)}
        >
          <Rupee className="mr-3" />
          <Typography variant="B2">{filterList.sortBy[1].title}</Typography>
        </Container>
      </Container>
      <div className="p-relative">
        <OutsideClickHandler onOutsideClick={() => setOpenSort(false)}>
          <Container
            className={sortOptionContainerclass}
            onClick={() => setOpenSort((prev) => !prev)}
            css={{ minWidth: "213px" }}
          >
            <SortIcon />
            <Container className="flex-column flex-1 ml-3 mr-4">
              <Typography variant="B2">Sort options</Typography>
              {!isEmpty(selectedFromDropdown) ? (
                <Typography variant="B2" colorCode="#808080">
                  {selectedFromDropdown?.title}
                </Typography>
              ) : null}
            </Container>

            <DownArrow
              className={openSort ? "rotate-clockwise" : "rotate-antiClockwise"}
            />
          </Container>
          <DropdownOptions
            openDropdown={openSort}
            wrapperClass="t-56 bg-neutral-100 p-absolute w-100p z-10 c-pointer"
          >
            {filterList.sortBy.map((item, index) => {
              if (index > 1)
                return (
                  <div
                    className="p-4 global-hover"
                    key={index}
                    onClick={() => handleSortSelection(item, index)}
                  >
                    <Typography variant="B1">{item.title}</Typography>
                  </div>
                );
            })}
          </DropdownOptions>
        </OutsideClickHandler>
      </div>
    </Container>
  );
};

export default SortingBar;
